(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("loom-services", [], factory);
	else if(typeof exports === 'object')
		exports["loom-services"] = factory();
	else
		root["loom-services"] = factory();
})(self, function() {
return 